// 720000 is 12 min -> good to see on the button - 900000 - 15 min
export const sysConfig = {

  "idleDelayMs": 720000

}